import config from './config';

const authProvider = {
    login: ({ username, password }) =>  {
        const request = new Request(`${config.apiUrl}/admin/v1/login`, {
            method: 'POST',
            body: JSON.stringify({ 'email': username, 'password': password }),
            headers: new Headers({ 'Content-Type': 'application/json' }),
        });
        return fetch(request)
            .then(response => {
                if (response.status < 200 || response.status >= 300) {
                    throw new Error('Incorrect username or password');
                }
                return response.json();
            })
            .then(auth => {
                localStorage.setItem('auth', JSON.stringify(auth));
            })
    },
    checkError: (error) => {
        const status = error.status;
        if (status === 401 || status === 403) {
            localStorage.removeItem('auth');
            return Promise.reject();
        }
        // other error code (404, 500, etc): no need to log out
        return Promise.resolve();
    },
    checkAuth: () => localStorage.getItem('auth')
        ? Promise.resolve()
        : Promise.reject(),
    logout: () => {
        localStorage.removeItem('auth');
        return Promise.resolve();
    },
    getPermissions: () => localStorage.getItem('auth')
        ? Promise.resolve('admin')
        : Promise.resolve('guest')
};

export default authProvider;